var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "layout-base" } },
    [
      _c(
        "topbar",
        [_c("template", { slot: "topbar" }, [_vm._t("topbar")], 2)],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "main" } },
        [
          _c(
            "sidebar-left-stacked",
            [
              _c(
                "template",
                { slot: "sidebar-left-stacked" },
                [_vm._t("sidebar-left-stacked")],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "sidebar-left",
            [
              _c(
                "template",
                { slot: "sidebar-left" },
                [_vm._t("sidebar-left")],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "main-canvas",
            [
              _c(
                "template",
                { slot: "main-canvas" },
                [
                  _vm._t("secondary-nav"),
                  _vm._v(" "),
                  _vm._t("main-canvas-ad"),
                  _vm._v(" "),
                  _vm._t("main-canvas"),
                  _vm._v(" "),
                  _vm._t("sidebar-bottom"),
                ],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "sidebar-right",
            [
              _c(
                "template",
                { slot: "sidebar-right" },
                [_vm._t("sidebar-right")],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }